import { DashboardLayout, DashboardViewFragment } from 'generated/graphql';
import { generateMetadataV2 } from './generateMetadataV2';

interface resetLayoutIfRequiredParams {
  layout?: DashboardLayout;
  dashboard: DashboardViewFragment;
}

export function resetLayoutIfRequired({
  layout,
  dashboard,
}: resetLayoutIfRequiredParams) {
  const cellsCount = layout?.rows.reduce(
    (acc, row) => acc + row.cells.length,
    0,
  );

  if (cellsCount === dashboard?.widgets?.length) {
    return layout;
  }

  // Reset layout if there is a mismatch between layout and analyses
  return generateMetadataV2(dashboard.widgets).layout;
}
